import React from 'react';
import { Box, IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

// Shared color palette (should match other components)
const COLOR_PALETTE = [
  { id: 'orange', hex: '#FF9800', name: 'Orange', suffix: '' },
  { id: 'red', hex: '#F44336', name: 'Red', suffix: 'red' },
  { id: 'green', hex: '#4ade80', name: 'Green', suffix: 'green' },
  { id: 'blue', hex: '#60a5fa', name: 'Blue', suffix: 'blue' }
];

/**
 * Photoshop-style manager allowing color selection & visibility toggling in one list.
 */
const ColorLayerManager = ({
  currentColor = 'orange',
  onColorSelect,
  visibleColors = ['orange', 'red', 'green', 'blue'],
  onToggleColorVisibility
}) => {
  const handleSelect = (colorId) => {
    if (onColorSelect) onColorSelect(colorId);
  };

  const handleToggleVisibility = (e, colorId) => {
    e.stopPropagation(); // prevent triggering color select
    if (onToggleColorVisibility) onToggleColorVisibility(colorId);
  };

  return (
    <Box className="color-layer-manager" sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {COLOR_PALETTE.map((color) => {
        const isVisible = visibleColors.includes(color.id);
        const isSelected = currentColor === color.id;
        return (
          <Box
            key={color.id}
            onClick={() => handleSelect(color.id)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              cursor: 'pointer',
              p: 0.5,
              borderRadius: 1,
              backgroundColor: isSelected ? 'rgba(255,255,255,0.08)' : 'transparent',
              '&:hover': { backgroundColor: 'rgba(255,255,255,0.05)' }
            }}
          >
            <Box
              sx={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                backgroundColor: color.hex,
                border: isSelected ? '3px solid white' : '2px solid rgba(255,255,255,0.3)',
                boxShadow: '0 1px 4px rgba(0,0,0,0.4)'
              }}
            />
            <Box sx={{ flexGrow: 1, color: '#fff', fontSize: '0.8rem' }}>
              {color.name}
            </Box>
            <IconButton
              size="small"
              onClick={(e) => handleToggleVisibility(e, color.id)}
              sx={{ color: isVisible ? '#fff' : 'rgba(255,255,255,0.4)' }}
            >
              {isVisible ? <VisibilityIcon fontSize="small" /> : <VisibilityOffIcon fontSize="small" />}
            </IconButton>
          </Box>
        );
      })}
    </Box>
  );
};

export default ColorLayerManager;
